import { createSlice } from "@reduxjs/toolkit";

import CacheUtils from "../../utils/cache-utils";
import { User } from "./user-api";

export interface AuthSlice {
  token: string | null;
  synergyToken: string | null;
  isAuthenticated: boolean;
  loading: boolean;
  user: User | null;
}

const initialState: AuthSlice = {
  token: CacheUtils.getAccessToken(),
  isAuthenticated: false,
  loading: true,
  synergyToken: CacheUtils.getSynergyToken(),
  user: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    userLoggedIn: (state) => {
      try {
        const token = CacheUtils.getAccessToken();
        state.token = token;
        state.isAuthenticated = true;
        state.loading = false;
      } catch (err) {
        console.error("authSlice | loginUser | ", err);
        state.loading = false;
      }
    },
    userLoggedInSynergy: (state) => {
      try {
        const synergyToken = CacheUtils.getSynergyToken();
        state.synergyToken = synergyToken;
      } catch (err) {
        console.error("authSlice | loginUser | ", err);
      }
    },
    saveUser: (state, action) => {
      try {
        state.user = action.payload;
      } catch (err) {
        console.error("authSlice | saveUser | ", err);
      }
    },
  },
});

export const { userLoggedIn, userLoggedInSynergy, saveUser } = authSlice.actions;
export const authSliceReducer = authSlice.reducer;
